import { useRouter } from 'next/router'
import { useSelector } from 'react-redux'
export const useRouterBack = () => {
  const {
    reserve: { data },
  } = useSelector(state => state)
  const router = useRouter()

  const handleBack = () => {
    const reserveExists =
      router.query?.id && router.route.includes('reservations')
    if (
      router.pathname.includes('order-tracking') &&
      router.query.payment_status
    ) {
      return router.push({
        pathname: '/trips',
      })
    }
    if (
      reserveExists &&
      router.query?.utm_medium == 'sms' &&
      data?.[0]?.invoice?.id
    ) {
      router.push({
        pathname: (window.location.href = `${
          window.location.origin + '/order-tracking/' + data[0]?.invoice?.id
        }/show`),
      })
      return
    }
    if (sessionStorage.getItem('previous_page')) {
      router.back()
    } else {
      router.push({
        pathname: '/',
      })
    }
  }
  return { handleBack }
}

export default useRouterBack
